
<div class="hidden-sm hidden-md hidden-lg ">
  <app-nav ></app-nav>
</div>
<div class="visible-lg">
<app-headerhome ></app-headerhome>
</div>
<div class="container _mt-50 bg-buupass">
</div>

<div class="theme-page-section  theme-page-section-lg">
    <div class="container ">
      <div class="row">
         <!-- Sidebar -->
    <div class="col-md-3 col-lg-3 mb-4">
      <app-account-header
        [activeTab]="activeTab"
        (scrollToSection)="scrollTo($event)">
      </app-account-header>
    </div>
    
    <div class="col-md-9 col-lg-9">
      <div class="notifications-section">
        <h3 class="notifications-title">Notifications</h3>
    
        <div class="notifications-content">
          <div class="notifications-card">
            <h4 class="notifications-subtitle">Promotions</h4>
    
            <div class="notifications-toggle">
              <label class="notifications-switch">
                <input type="radio" name="switch-choice">
                <span class="slider round"></span>
              </label>
              <span class="notifications-label">Email</span>
            </div>
    
            <div class="notifications-description">
              <div class="card">
                <div class="card-body">
                  Receive coupons, promotions, surveys, product updates,
                  <br>
                  and travel inspiration from buupass and our partners.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    

      </div>
    </div>
</div>
